// src/services/ImageCacheService.js
const DB_NAME = 'MindMovieImageCache';
const STORE_NAME = 'images';
const EXPIRY_DAYS = 30;

export default {

  // HELPERS
  async openDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'url' });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  },



  // IMAGE CACHE
  async getImage(url) {
    const db = await this.openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const request = store.get(url);

      request.onsuccess = () => {
        const record = request.result;
        if (!record) return resolve(null);

        const now = Date.now();
        if (now > record.expiry) { // expired - delete it
          this.deleteImage(url);
          resolve(null);
        } else {
          resolve(record.blob);
        }
      };
      request.onerror = () => reject(request.error);
    });
  },

  async saveImage(url, blob) {
    const db = await this.openDB();
    const expiry = Date.now() + (EXPIRY_DAYS * 24 * 60 * 60 * 1000);

    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);

      const record = { url, blob, expiry };
      const request = store.put(record);

      request.onsuccess = () => resolve(true);
      request.onerror = () => reject(request.error);
    });
  },

  async deleteImage(url) {
    const db = await this.openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.delete(url);
  },


  // Optional: clean up old entries periodically
  async cleanupExpired() {
    // you can call this on app load sometimes
  }
};
